import { createStyles } from '@mantine/emotion';

export default createStyles((theme) => ({
  infiniteList: {
    minHeight: '200px',
    minWidth: '100px',
  },

  item: {
    alignItems: 'center',
  },

  selected: {
    backgroundColor: theme.colors[theme.primaryColor][0],
  },

  nothingFound: {
    boxSizing: 'border-box',
    color: theme.colors.gray[6],
    paddingTop: `calc(${theme.spacing.md} / 2)`,
    paddingBottom: `calc(${theme.spacing.md} / 2)`,
    textAlign: 'center',
  },
}));
